import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const HeroLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] -mb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`font-head font-bold uppercase tracking-[0.22em] text-xs sm:text-sm ${
      light ? "text-[#C58A47]" : "text-[#C58A47]"
    }`}
  >
    {children}
  </span>
);

export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden bg-[#233D35] border-y border-[#233D35] py-4" aria-hidden="true" data-testid="region-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-head font-semibold uppercase tracking-[0.18em] text-sm sm:text-base text-[#F3EFE5]/80 px-6">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#C58A47]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
